console.log('jQuery:', window.jQuery, '$:', window.$);
/* IMPORTANT 1 */
if (typeof window.jQuery !== 'undefined') {
  window.$ = window.jQuery;
}
/* LEMON */

// webpack imports js
import './_scroll.js';
import './_stewie.js';
import './_tabs.js';
import './_health-services-search.js';
import './_jquery.modal.js';
import './_anchorHandler.js';


//Custom scripts
import './_custom.js'; // load this last

// webpack imports scss
import '../scss/index.scss';